// @flow

import * as React from 'react'
import { Divider } from 'semantic-ui-react'
import Link from 'redux-first-router-link'

type Props = {|
  campaignName: string,
  isAdmin: boolean,
  isViewer: boolean,
  isActive: boolean,
  currentUser: string,
  onSetCampaignStatus: () => void,
  onDropCampaign: () => void,
  wavesCount: number,
  totalVisits: number,
|}

const ActionsSection = (props: Props) => {
  let verb = props.isAdmin ? 'Gestisci' : 'Visualizza'
  return (
    <div className="column">
      <Divider horizontal>Actions</Divider>
      {props.isViewer === false && (
        <span>
          <Link to={'/panels/' + props.campaignName}>{`${verb} panel`}</Link> <br />
          <Link to={'/visits/' + props.campaignName}>Gestisci visite</Link> <br />
          <div style={{ borderBottom: 'solid 1px #dedede', width: '100%', height: '1px', margin: '1ex 0' }} />
          <Link style={{ display: 'block' }} to={'/reports/details/' + props.campaignName}>
            Dettaglio visite
          </Link>
        </span>
      )}
      <Link style={{ display: 'block' }} to={'/reports/calendar/' + props.campaignName}>
        Calendario visite
      </Link>
      <Link style={{ display: 'block' }} to={'/reports/chart/' + props.campaignName}>
        Andamento temporale
      </Link>
      {props.isAdmin && (
        <div>
          <div style={{ borderBottom: 'solid 1px #dedede', width: '100%', height: '1px', margin: '1ex 0' }} />
          <div>
            <a style={{ display: 'block', cursor: 'pointer', color: 'red' }} onClick={props.onSetCampaignStatus}>
              {(props.isActive ? 'Disattiva' : 'Attiva') + ' campagna'}
            </a>
            {(props.totalVisits === 0 || props.currentUser === 'admin') && (
              <a style={{ display: 'block', cursor: 'pointer', color: 'red' }} onClick={props.onDropCampaign}>
                {(props.currentUser === 'admin' ? 'Distruggi' : 'Elimina') + ' campagna'}
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ActionsSection



// WEBPACK FOOTER //
// ./src/campaigns/actions-section.js